import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { change } from 'redux-form';
import { connect } from 'react-redux';

import { TextInput, FileInput, SelectInput } from 'components/input';
import { ImageField } from 'components/field';
import { SimpleForm } from 'components/form';
import { Edit } from 'components/detail';

import { uploadNewsImage as uploadNewsImageAction } from 'actions';

import { RichTextInputWithImage } from './components/RichTextInputWithImage';
import { maxLength, validCustomURL } from "components/form/validate";
import imageHandlerForRichTextInput from 'util/imageHandlerForRichTextInput';
import {
  InputOptions,
} from 'util/constants';
import * as urls from './urls';
import * as utils from './utils';


function cleanAccents(str) {
  let s = ''
  const s1 = 'ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚÝàáâãèéêìíòóôõùúýĂăĐđĨĩŨũƠơƯưẠạẢảẤấẦầẨẩẪẫẬậẮắẰằẲẳẴẵẶặẸẹẺẻẼẽẾếỀềỂểỄễỆệỈỉỊịỌọỎỏỐốỒồỔổỖỗỘộỚớỜờỞởỠỡỢợỤụỦủỨứỪừỬửỮữỰựỲỳỴỵỶỷỸỹ';
  const s0 = 'AAAAEEEIIOOOOUUYaaaaeeeiioooouuyAaDdIiUuOoUuAaAaAaAaAaAaAaAaAaAaAaAaEeEeEeEeEeEeEeEeIiIiOoOoOoOoOoOoOoOoOoOoOoOoUuUuUuUuUuUuUuYyYyYyYy';
  for (let i = 0; i < str.length; i++) {
    const c = str.charAt(i);
    if (s1.includes(c)) {
      s += s0[s1.indexOf(c)];
    } else {
      s += c;
    }
  }

  return s;
}

const container = [
  [{'header': [1, 2, 3, 4, 5, 6, false]}],
  ['bold', 'italic', 'underline'],
  [{ 'size': ['small', false, 'large', 'huge'] }], 
  [{ 'color': [] }, { 'background': [] }],
  [{ 'align': [] }, 'blockquote', 'code-block'],
  [{'list': 'ordered'}, {'list': 'bullet'}],
  ['link', 'image', 'video'],
  ['clean'],
];

const mapStateToProps = (state) => {
  return {
    newsImageObj: state.admin['newsImage'],
    isLoading: state.admin.loading > 0,
  }
};

class NewsEditBase extends Component {

  static propTypes = {
    uploadNewsImage: PropTypes.func,
  };

  imageHandler = () => {
    imageHandlerForRichTextInput(this.props.uploadNewsImage);
  };

  constructor() {
    super();
    this.toolbar = {
      container: container,
      handlers: {
        'image': this.imageHandler
      }
    }
  }

  handleSubmit = (props, basePath) => (record) => {
    const formDataRecord = new FormData();
    formDataRecord.append('caption', record['caption']);
    formDataRecord.append('caption_en', record['caption_en'] || '');
    formDataRecord.append('url', record['url']);
    formDataRecord.append('description', record['description']);
    formDataRecord.append('description_en', record['description_en'] || '');
    formDataRecord.append('content', record['content']);
    formDataRecord.append('content_en', record['content_en'] || '');
    formDataRecord.append('cover_photo', record['cover_photo'] || 'no-previous.png');
    if (record['new_cover_photo']) {
      formDataRecord.append('new_cover_photo', record['new_cover_photo'] || '');
    }
    formDataRecord.append('cover_photo_en', record['cover_photo_en'] || 'no-previous.png');
    if (record['new_cover_photo_en']) {
      formDataRecord.append('new_cover_photo_en', record['new_cover_photo_en'] || '');
    }

    formDataRecord.append('category', record['category']);

    props.crudUpdate(
      props.resource, props.id, formDataRecord, props.data, props.editBackendPath, basePath);
  };

  render() {
    const { newsImageObj } = this.props;
    return (
      <Edit
        editBackendPath={urls.newsEditBackendPath}
        handleSubmit={this.handleSubmit}
        {...this.props}
      >
        <SimpleForm>
          <TextInput
            source='caption'
            label='Caption'
            isRequired={true}
            validators={[maxLength(256)]}
            options={InputOptions}
          />
          <TextInput
            source='caption_en'
            label='Caption English'
            validators={[maxLength(256)]}
            options={InputOptions}
          />
          <TextInput
            source='url'
            label='Custom URL'
            isRequired={true}
            validators={[validCustomURL, maxLength(100)]}
            options={InputOptions}
            onChange={(e) => {
              setTimeout(() => {
                this.props.updateCustomURL(e.target.value);
              }, 100);
            }}
          />
          <TextInput
            source='description'
            label='Description'
            isRequired={true}
            options={InputOptions}
          />
          <TextInput
            source='description_en'
            label='Description English'
            options={InputOptions}
          />
          <SelectInput
            source='category'
            label='Category'
            choices={utils.NEWS_CREATE_CATEGORY_CHOICES}
            defaultValue={utils.NEWS_CATEGORY_PRODUCT_UPDATES}
            isRequired={true}
            options={InputOptions}
          />
          <ImageField addLabel={true} source="cover_photo" label="Current Cover Photo"/>
          <FileInput
            source='new_cover_photo'
            label='New Cover Photo'
            placeholder={<p>Select or drop your file here</p>}
          >
            <ImageField source="src" title="title"/>
          </FileInput>
          <ImageField addLabel={true} source="cover_photo_en" label="Current Cover Photo English"/>
          <FileInput
            source='new_cover_photo_en'
            label='New Cover Photo English'
            placeholder={<p>Select or drop your file here</p>}
          >
            <ImageField source="src" title="title"/>
          </FileInput>
          <RichTextInputWithImage
            source='content'
            label='Content'
            imageObj={newsImageObj}
            toolbar={this.toolbar}
            defaultValue=''
          />
          <RichTextInputWithImage
            source='content_en'
            label='Content English'
            imageObj={newsImageObj}
            toolbar={this.toolbar}
            defaultValue=''
          />
        </SimpleForm>
      </Edit>
    )
  }
}

export const NewsEdit = connect(
  mapStateToProps,
  { 
    uploadNewsImage: uploadNewsImageAction,
    updateCustomURL: (caption) => {
      const clean_url = cleanAccents(caption.toLowerCase()).replace(/\s/g, '-').replace(/[^\w\s-]/gi, '');
      return change('record-form', 'url', clean_url.substring(0, 100));
    },
  },
)(NewsEditBase);

export const NewsEditStatus = (props) => (
  <Edit editBackendPath={urls.newsEditStatusBackendPath}{...props}>
    <SimpleForm>
      <SelectInput source='status' label='Status' choices={utils.NEWS_STATUS_CHOICES} isRequired={true}/>
      <SelectInput source='highlight' label='Highlight' choices={utils.HIGHLIGHT_CHOICES} isRequired={true}/>
      <SelectInput source='headline' label='Headline' choices={utils.HEADLINE_CHOICES} isRequired={true}/>
    </SimpleForm>
  </Edit>
);

class NewsBannerEditBase extends Component {

  static propTypes = {
    uploadNewsImage: PropTypes.func,
  };

  imageHandler = () => {
    imageHandlerForRichTextInput(this.props.uploadNewsImage);
  };

  constructor() {
    super();
    this.toolbar = {
      container: container,
      handlers: {
        'image': this.imageHandler
      }
    }
  }

  handleSubmit = (props, basePath) => (record) => {
    const formDataRecord = new FormData();
    formDataRecord.append('caption', record['caption']);
    formDataRecord.append('description', record['description']);
    formDataRecord.append('content', record['content']);
    formDataRecord.append('cover_photo', record['cover_photo']);
    if (record['new_cover_photo']) {
      formDataRecord.append('new_cover_photo', record['new_cover_photo']);
    }

    props.crudUpdate(
      props.resource, props.id, formDataRecord, props.data, props.editBackendPath, basePath);
  };

  render() {
    const { newsImageObj } = this.props;
    return (
      <Edit
        editBackendPath={urls.newsBannerEditBackendPath}
        handleSubmit={this.handleSubmit}
        {...this.props}
      >
        <SimpleForm>
          <TextInput
            source='caption'
            label='Caption'
            isRequired={true}
            validators={[maxLength(256)]}
            options={InputOptions}
          />
          <RichTextInputWithImage
            source='content'
            label='Content'
            imageObj={newsImageObj}
            toolbar={this.toolbar}
            defaultValue=''
          />
        </SimpleForm>
      </Edit>
    )
  }
}

export const NewsBannerEdit = connect(
  mapStateToProps,
  { uploadNewsImage: uploadNewsImageAction }
)(NewsBannerEditBase);

export const NewsBannerEditStatus = (props) => (
  <Edit editBackendPath={urls.newsBannerEditStatusBackendPath}{...props}>
    <SimpleForm>
      <SelectInput source='status' label='Status' choices={utils.NEWS_STATUS_CHOICES} isRequired={true}/>
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/routes/news/NewsEdit.js